import {
  getSessionData,
  getVersionedCallbackUrl,
  redirectToWebform,
} from "@repo/shared-utils/common-utils";
import { getOrDefaultValue } from "@repo/shared-utils/insert-params";
import { isOpenInApp } from "@repo/shared-utils/pwa-utils";
import { SSORedirectHandler } from "../../../../apps/trading-mall-app/app/components/ClickHandler/RedirectionConfig.interface";
import { getUserDetails } from "../services/demogApi";
import {
  getApplicationIdAndProdCode,
  type IBlInsertApiRequest,
  type IBlInsertApiResponse,
  postBlInsert,
  redirectionInAppWebform,
} from "./utils";
import { offerAPI } from "../../../api-client/src/services/icors.service";

interface ISetFormData {
  resume: boolean;
  custType: string;
  applicationID?: string;
  product?: string;
  prodCode?: string;
  blResData?: IBlInsertApiResponse;
}

const setFormData = ({
  custType,
  applicationID,
  product,
  prodCode,
  blResData,
  resume,
}: ISetFormData) => {
  const hasApplicationId = Boolean(blResData?.id ?? applicationID);
  return {
    custType,
    product: product ?? "BL",
    applicationID: blResData?.id ?? applicationID ?? "",
    prodCode: prodCode ?? "",
    resume: hasApplicationId ? resume : false,
  } as const;
};

export const blHandler: SSORedirectHandler = async (data) => {
  sessionStorage.setItem("blWebformJourneyStartedPage", window.location.pathname);

  const { custType, mobileNo } = await getSessionData();
  const [applicationID, prodCode] = await getApplicationIdAndProdCode(data, ["BL"]);
  const resume = Boolean(applicationID);
  const product = data.mapping?.ssoProduct?.[0];

  const callbackUrl = await getVersionedCallbackUrl(data.mapping);

  const offerData = await offerAPI("bl");
  const selectedOffer = offerData?.at(0);
  const userData = await getUserDetails(mobileNo);
  const blInsertData = data.data?.blInsert ?? {};

  const payload: IBlInsertApiRequest = {
    mobileNo,
    journeyName: getOrDefaultValue(selectedOffer?.journeyName, "PSBL_NTB"),
    custType: getOrDefaultValue(userData.data?.custType),
    offerId: getOrDefaultValue(selectedOffer?.offerId),
    offerName: getOrDefaultValue(selectedOffer?.offerName),
    loanAmt: getOrDefaultValue(blInsertData.amount),
    offerAmt: getOrDefaultValue(selectedOffer?.icorsAmount),
    tenureInMon: getOrDefaultValue(blInsertData.initialTenure),
    loanVariant: getOrDefaultValue(blInsertData.variant),
    initialTenor: getOrDefaultValue(blInsertData.initialTenor),
    subsequentTenor: getOrDefaultValue(blInsertData.subsequentTenor),
    roi: getOrDefaultValue(blInsertData.roi),
    hybridEmiAmt: getOrDefaultValue(blInsertData.hybridEmiAmt),
    droplineEmiAmt: getOrDefaultValue(blInsertData.droplineEmiAmt),
    emiAmt: getOrDefaultValue(blInsertData.initialEmi),
    actualEmiAmt: getOrDefaultValue(blInsertData.actualEmiAmt),
    maxLoanVariant: getOrDefaultValue(blInsertData.maxLoanVariant),
    maxLoanTenor: getOrDefaultValue(blInsertData.maxLoanTenor),
    addOnProd: blInsertData.addOnProd || [],
    appId: applicationID ?? data.data?.applicationId,
  };

  const blResData = await postBlInsert(payload);
  const formData = setFormData({
    custType,
    product: product ?? "BL",
    blResData,
    resume,
    applicationID,
    prodCode,
  });

  if (isOpenInApp()) {
    await redirectionInAppWebform(
      String(formData.applicationID || ""),
      "BL",
      undefined,
      Boolean(formData.resume)
    );
    return;
  }

  redirectToWebform(callbackUrl.toString(), formData);
  return;
};
